import React from 'react';
import { useTranslation } from '../i18n/useTranslation';

const GOLD = '#C9A84C';

export default function MaestroVerifiedBadge({ compact = false, className = '' }) {
  const { t } = useTranslation();

  return (
    <span
      className={`inline-flex items-center gap-1 font-semibold ${compact ? 'text-[9px] px-1.5 py-0.5' : 'text-[10px] px-2 py-0.5'} rounded-full ${className}`}
      style={{
        color: '#1a1a2e',
        background: `linear-gradient(135deg, ${GOLD}, #e0c068)`,
        letterSpacing: '0.03em',
        whiteSpace: 'nowrap',
      }}
      title={t('verified.badge_title')}
    >
      <svg width={compact ? 10 : 11} height={compact ? 10 : 11} viewBox="0 0 24 24" fill="none" aria-hidden>
        <path
          d="M12 2l2.2 4.5 5 .7-3.6 3.5.9 5.1L12 13.8 7.5 16.8l.9-5.1L4.8 7.2l5-.7L12 2z"
          fill="#1a1a2e"
        />
      </svg>
      {t('verified.badge')}
    </span>
  );
}
